import React from 'react';

import { clsName } from '../../utils/helpers';
import styles from './NotFoundSection.module.scss';
import { h2 } from '../../styles/typography.module.scss';

const NotFoundSection = () => (
  <div className={styles.NotFoundSection}>
    <div className={styles.LeftContent}>
      <div className={clsName(h2, styles.Title)}>Oops, we can't find that page</div>
      <div className={clsName(styles.Description)}>How about watching a cat video instead?</div>
    </div>
    <div className={styles.RightContent}>
      <div className={styles.TopBorder}>
        <img src="/static/img/sparkle_top.png" alt="" />
      </div>
      <iframe
        title="video"
        className={styles.Video}
        src="https://www.youtube-nocookie.com/embed/uvLNYNiw5I0"
        frameBorder="0"
        allowFullScreen
      />
      <div className={styles.BottomBorder}>
        <img src="/static/img/sparkle_bottom.png" alt="" />
      </div>
    </div>
  </div>
);

export default NotFoundSection;
